import * as React from 'react';
import { memo, useContext } from 'react';
import { Col, Row, Space } from 'antd';
import clsx from 'clsx';
import { Category } from '../knowledge-base.type';
import { RightOutlined } from '@ant-design/icons';
import { MobileContext } from '/react4xp/parts/knowledge-base/knowledge-base';

interface CategoryListProps {
    categories: Category[];
    children?: React.ReactNode;
    activeCategory: Category;
    selectCategory: (category: Category) => void;
}

const CategoryList = memo(
    ({ categories, children, activeCategory, selectCategory }: CategoryListProps) => {
        const isMobile = useContext(MobileContext);
        return (
            <Row
                gutter={20}
                wrap={false}
            >
                {(!isMobile || !activeCategory) && (
                    <Col flex="1 0 320px">
                        <Space
                            direction="vertical"
                            size={16}
                            style={{ display: 'flex' }}
                        >
                            <Space
                                direction="vertical"
                                size={16}
                                style={{ display: 'flex' }}
                            >
                                {categories.map((category) => (
                                    <button
                                        key={category.id}
                                        className={clsx('button-card', 'button-card__category', {
                                            'button-card__active': activeCategory === category,
                                        })}
                                        onClick={() => selectCategory(category)}
                                    >
                                        {category.title}
                                        <RightOutlined />
                                    </button>
                                ))}
                            </Space>
                        </Space>
                    </Col>
                )}
                <Col flex="1 1 1600px">{children}</Col>
            </Row>
        );
    }
);

export default CategoryList;
